import { AccessCollection, AccessItem } from '../../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';
import { isDefined, undefinedIfEmpty } from '../../helpers/utils';

@customElement('form-input-access')
export class FormInputButton extends LitElement {

    @property({ type: String })
    type?: string = 'topic';

    @property({ type: String })
    label: string = '';

    @property({ type: String })
    placeholder: string = '';

    @property({ type: Boolean })
    isOwner: boolean = false;

    @property({ type: Boolean })
    isOpenMobileSelectBox: boolean = false;

    @property({ type: Boolean })
    hideRole: boolean = false;

    @state()
    value: string = '';

    @state()
    currentOption: string = '';


    @state()
    options: Array<Record<string, any>> = this.type !== undefined && isDefined(AccessCollection[this.type])
        ? AccessCollection[this.type]
            .filter((accessItem: AccessItem) => accessItem.limited === false || this.isOwner)
            .map((accessItem: AccessItem) => {
                return {
                    value: accessItem.value,
                    name: accessItem.name,
                };
            })
        : [];

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('type')) {
            this.options = this.type !== undefined && isDefined(AccessCollection[this.type])
                ? AccessCollection[this.type]
                    .filter((accessItem: AccessItem) => accessItem.limited === false || this.isOwner)
                    .map((accessItem: AccessItem) => {
                        return {
                            value: accessItem.value,
                            name: accessItem.name,
                        };
                    })
                : [];
            this.currentOption = undefinedIfEmpty(this.value) ?? this.options[this.options?.length - 1]?.value;
            this.requestUpdate();
        }
    }

    private handleChange(e: Event) {
        this.value = (e.target as HTMLInputElement).value;
    }

    private handleClick(e: Event) {
        this.dispatchEvent(
            new CustomEvent('submit', {
                detail: {
                    value: this.value,
                    option: this.currentOption,
                },
            })
        );
        this.value = '';
    }

    private handleClickOption(newValue: string | undefined) {
        if (!newValue || newValue==='') {
            return;
        }
        this.currentOption = newValue;
        this.toggleOpenSelectBox();
    }

    private toggleOpenSelectBox() {
        this.isOpenMobileSelectBox = !this.isOpenMobileSelectBox;
    }

    render() {
        return html`
            ${this.label !== '' ? html` <div class="inputLabel">${this.label}</div> ` : ''}
            <div class="flexContainer">
                <proxi-textfield
                    outlined
                    id="textbox"
                    value="${this.value}"
                    type="email"
                    placeholder="${this.placeholder}"
                    @change="${this.handleChange}"
                >
                </proxi-textfield>
                ${this.hideRole ? '' : html`
                    <proxi-selectfield
                        style="flex:1"
                        outlined
                        id="accessLevelSelect"
                        value="${this.currentOption ?? this.options[this.options?.length - 1] ?? ''}"
                        @selected="${(e: any) => this.handleClickOption(e.target.value)}"
                    >
                        ${this.options.map((option: Record<string, any>) => {
                            return html`
                                <mwc-list-item value="${option.value}">${option.name}</mwc-list-item>
                            `;
                        })
                        }
                    </proxi-selectfield>
                `}
                <mwc-icon-button @click="${this.handleClick}"
                    raised
                    icon="send"
                    ?disabled="${!this.value.includes('@') || !isDefined(undefinedIfEmpty(this.currentOption))}"
                    class="sendButton">
                </mwc-icon-button>
            </div>

        `;
    }

    static get styles() {
        return css`
            .flexContainer {
                display: flex;
                align-items: center;
                gap: 5px;
            }

            .alignCenter {
                align-items: center;
            }

            .inputLabel {
                font-size: 20px;
                color: var(--main-primary-color);
                margin-bottom: 0.5rem;
            }

            #accessLevel {
                width: 165px;
                padding-left: 1rem;
                padding-right: 1rem;
                border: 1px solid var(--main-primary-color);
                margin-left: -1px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                position: relative;
            }

            #currentMenuOption {
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;
            }

            #cornerMenu {
                position: absolute;
                margin-top: -60%;
                background: white;
                border: 1px solid var( --theme-border-color);
            }

            #textbox {
                flex: 1;
            }

            #textbox:focus {
                border-color: var(--theme-focus-border-color);
                background-color: var(--theme-white-color);
                outline: 0;
            }

            .form-btn {
                margin-left: -1px;
                min-width: 134px;
            }

            .form-btn:hover {
                opacity: 0.8;
            }

            .sendButton {
                color: var(--main-success-color);
            }

            #overlayBackground {
                background: var(--theme-overlay-background-color);
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            #overlayOptions {
                background: var(--theme-white-color);
                box-sizing: border-box;
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                padding: 1rem 0.5rem;
            }

            .optionItem {
                padding: 1rem;
            }

            .optionItem.selected {
                background: var(--main-featured-color);
                border-radius: 1rem;
            }

            .optionIcon {
                width: 3rem;
                height: 1.75rem;
            }

            @media screen and (max-width: 900px) {
                #accessLevel {
                    width: 120px;
                }
            }

            @media (min-width: 551px) {
                .desktopOnly {
                    display: block;
                }

                .desktopOnly.flexContainer {
                    display: flex;
                }

                .mobileOnly {
                    display: none;
                }
            }

            @media (max-width: 550px) {
                .desktopOnly {
                    display: none;
                }

                .mobileOnly {
                    display: block;
                }

                .mobileOnly.flexContainer {
                    display: flex;
                }
            }
        `;
    }
}
